import React from "react";
import BackgroundTitle from "../../components/ui/BackgroundTitle";
import Doctor from "../../components/ui/cards/Doctor";

function Doctors() {
  return (
    <>
      <div>
        <BackgroundTitle title='WELL EXPERIENCED DOCTORS' />
      </div>
      <div className='px-5 sm:px-7 lg:px-14 xl:px-48 py-28'>
        <div className='flex justify-center items-center'>
          <div className='grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-10 sm:gap-14'>
            <Doctor
              title='Dr. John Doe'
              dic='Cardiologist'
              pic={require("../../assets/doctors/1.webp")}
            />
            <Doctor
              title='Aldin Powell'
              dic='Neurologist'
              pic={require("../../assets/doctors/2.webp")}
            />
            <Doctor
              title='Aldin Powell'
              dic='Pediatrician'
              pic={require("../../assets/doctors/3.webp")}
            />
            <Doctor
              title='Aldin Powell'
              dic='Pulmonologist'
              pic={require("../../assets/doctors/4.webp")}
            />
            <Doctor
              title='Aldin Powell'
              dic='Neurologist'
              pic={require("../../assets/doctors/2.webp")}
            />
            <Doctor
              title='Dr. John Doe'
              dic='Cardiologist'
              pic={require("../../assets/doctors/1.webp")}
            />
            <Doctor
              title='Aldin Powell'
              dic='Pulmonologist'
              pic={require("../../assets/doctors/4.webp")}
            />
            <Doctor
              title='Aldin Powell'
              dic='Pediatrician'
              pic={require("../../assets/doctors/3.webp")}
            />
          </div>
        </div>
        <div className='flex justify-center items-center gap-1.5 text-primary mt-10'>
          <p className='px-3 py-1 hover:cursor-pointer border border-sky-200 rounded-full'>
            {"<"}
          </p>
          <p className='px-3 py-1 hover:cursor-pointer border border-sky-200 rounded-full bg-green-200'>
            1
          </p>
          <p className='px-3 py-1 hover:cursor-pointer border border-sky-200 rounded-full'>
            2
          </p>
          <p className='px-3 py-1 hover:cursor-pointer border border-sky-200 rounded-full'>
            3
          </p>
          <p className='px-3 py-1 hover:cursor-pointer border border-sky-200 rounded-full'>
            4
          </p>
          <p className='px-3 py-1 hover:cursor-pointer border border-sky-200 rounded-full'>
            5
          </p>
          <p className='px-3 py-1 hover:cursor-pointer border border-sky-200 rounded-full'>
            {">"}
          </p>
        </div>
      </div>
    </>
  );
}

export default Doctors;
